import React from "react";
import { withRouter } from "react-router";
import { DATE_FORMAT, PAGE_MODE } from "../../../../../constants/constants";
import BarButtonFw, { BUTTON_DEFAULT, } from "../../../../../framework/bar-button/BarButtonFw";
import FormFw from "../../../../../framework/form/FormFw"; 

import { MessageUtil } from "../../../../../util/MessageUtil";
import { UserUtil } from "../../../../../util/UserUtil";
import { BasePage } from "../../../../../framework/pages/BasePage";

 
class DatosProyectoSection extends BasePage {
    renderPage(pageApi) { 
      
    const getForm_datos_proyecto = () => pageApi.getComponent('formDatosProyecto'); 
 
    const formDatosProyecto = {
      layout: 'vertical', 
      load:{
          validation: () => pageApi.getParamId() != null, 
          queryId: 837,
          params: {id_doc: pageApi.getParamId()},
          // fnOk: (resp) => {
          //   getformDatosProyecto().load({params:{id_doc: pageApi.getParamId()}});  
            
          // },
          hideMessage: true, 
          hideMessageError: true
      },
      save: { 
      queryId: 832, 
      hideMessage: true, 
      hideMessageError: true,
      params: { id_doc: pageApi.getParamId(), est_tab : 4, id_user: UserUtil.getUserId() }, 
      fnOk: (resp) => {
          const id_doc = resp.dataObject?.id_doc;  
          const est_tab_actual = resp.dataObject?.est_tab;    

            if(est_tab_actual == 4){
              this.props.history.push(`/cotizaciones/cotizaciones/4/${id_doc}`)
            }
          
          this.props.cambiarTabPanel("4",id_doc); 
          return MessageUtil(
            "success",
            "Exito!",
            "Se ha habilitado Gastos Operativos"
          ); 
        }, 
      },
      title: '',
    //   collapsible: true,
      fields:[
          {
              label: '  ',
              fields: [
                {type: 'hidden', name: 'id_doc_cotizacion'},  
                { name: "nombre_proyecto", label: "Nombre del Proyecto", column: 4 },
                {
                  type: "select",
                  name: "cod_departamento",
                  label: "Departamento",
                  column: 4,
                  load: { queryId: 130 },
                  search: true,
                },
                {
                  type: "select",
                  name: "cod_provincia",
                  label: "Provincia",
                  column: 4,
                  load: { queryId: 133 },
                  search: true,
                  parents: [
                    {
                      name: "cod_departamento",
                      paramName: "cod_departamento",
                      required: true,
                    },
                  ],
                },
                {
                  type: "select",
                  name: "cod_distrito",
                  label: "Distrito",
                  column: 4,
                  load: {
                    queryId: 134,
                  },
                  search: true,
                  parents: [
                    {
                      name: "cod_provincia",
                      paramName: "cod_provincia",
                      required: true,
                    },
                    {
                      name: "cod_departamento",
                      paramName: "cod_departamento",
                      required: true,
                    },
                  ],
                },
              ]
          }
      ],
      onComponentLoad : (formApi, pageApi) =>{
          if (pageApi.getPageMode() !== PAGE_MODE.NEW)
              formApi.load();
      }
  
    }

 
 
    const barButtonFooterDatosProyecto = {
        fields: [
          { ...BUTTON_DEFAULT.RETURN, link: '/cotizaciones/cotizaciones-admin', alert: true, message: 'Está seguro de retornar?', },
          { ...BUTTON_DEFAULT.SAVE, label: 'Continuar',
              onClick: () => {
            
                if (getForm_datos_proyecto()?.getData()?.id_servicio == 10) {
                  let cod_departamento = getForm_datos_proyecto()?.getData().cod_departamento;             
                  let cod_provincia = getForm_datos_proyecto()?.getData().cod_provincia;              
                  let cod_distrito = getForm_datos_proyecto()?.getData().cod_distrito;             
                  let nombre_proyecto = getForm_datos_proyecto()?.getData().nombre_proyecto;
                  if (nombre_proyecto === null || !nombre_proyecto){ 
                      return MessageUtil('warning','Alerta!','Debe Ingresar Nombre Proyecto');
                  }
                  else if(cod_departamento === undefined){ 
                      return MessageUtil('warning','Alerta!','Debe Seleccionar Departamento');
                  }
                  else if (cod_provincia === null){ 
                      return MessageUtil('warning','Alerta!','Debe Seleccionar Provincia');
                  }
                  else if (cod_distrito === null){ 
                      return MessageUtil('warning','Alerta!','Debe Seleccionar Distrito');
                  }
                  else { 
                      getForm_datos_proyecto().save()
                  } 
                } else {
                  getForm_datos_proyecto().save()
                }
              }
          },
        ]
    }


    return (
      <>
        <FormFw
          name="formDatosProyecto"
          getParentApi={pageApi.getApi}
          config={formDatosProyecto} 
        />
 
        <BarButtonFw 
          name="barFooter"
          getParentApi={pageApi.getApi}
          config={barButtonFooterDatosProyecto} 
        />
      </>
    ); 
}
}

export default DatosProyectoSection